import request from '@/utils/request'
import { envInfo } from '@/constants/envInfo'

/**
*查询L1统计图形的数据
 * @param params
 */
export function getLevel1(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/level1',
        method: 'get',
        params
    })
}

/**
*查询L1列表的数据
 * @param params
 */
export function listLevel1(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/list',
        method: 'get',
        params
    })
}

/**
*查询l2电力统计图形的数据
 * @param params
 */
export function getPowerLevel2(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/power/level2',
        method: 'get',
        params
    })
}

/**
*查询l2电力列表的数据
 * @param params
 */
export function listPower(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/power/list',
        method: 'get',
        params
    })
}

/**
*查询L2水统计图形的数据
 * @param params
 */
export function getWaterLevel2(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/water/level2',
        method: 'get',
        params
    })
}

/**
*查询L2水列表的数据
 * @param params
 */
export function listWater(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/water/list',
        method: 'get',
        params
    })
}

/**
*空调
 * @param params
 */
export function getAirconditionLevel2(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/airconditionchild/level2',
        method: 'get',
        params
    })
}

/**
*空调
 * @param params
 */
export function listAircondition(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/airconditionchild/list',
        method: 'get',
        params
    })
}

/**
*动力
 * @param params
 */
export function getPowerchildLevel2(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/powerchild/level2',
        method: 'get',
        params
    })
}

/**
*动力
 * @param params
 */
export function listPowerchild(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/powerchild/list',
        method: 'get',
        params
    })
}

/**
*照明
 * @param params
 */
export function getLightchildLevel2(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/lightchild/level2',
        method: 'get',
        params
    })
}

/**
*照明
 * @param params
 */
export function listLightchild(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/lightchild/list',
        method: 'get',
        params
    })
}
/**
*特殊用电
 * @param params
 */
export function getSpecialchildLevel2(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/specialchild/level2',
        method: 'get',
        params
    })
}

/**
*特殊用电
 * @param params
 */
export function listSpecialchild(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/specialchild/list',
        method: 'get',
        params
    })
}
/**
*查询抄表录入信息的数据
 * @param params
 */
export function getChaobiaoList(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/input/list',
        method: 'get',
        params
    })
}

/**
*查询抄表录入信息的数据
 * @param params
 */
export function updateChaobiao(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/input/input',
        method: 'post',
        data: params
    })
}

/**
*查询抄表录入信息的数据
 * @param params
 */
export function getParameterList(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/influence/list',
        method: 'get',
        params
    })
}

/**
*查询抄表录入信息的数据
 * @param params
 */
export function updateParameter(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/influence/input',
        method: 'post',
        data: params
    })
}

/**
*查询能耗影响原因
 * @param params
 */
export function getInfluenceElementList(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/element/list',
        method: 'get',
        params
    })
}
/**
*修改能耗影响原因
 * @param params
 */
export function updateInfluenceElement(params) {
    return request({
        url: envInfo.bgApp.cameraPath + '/camera/consumption/element/input',
        method: 'post',
        data: params
    })
}  
/**
* 导出excel
* @param params
*/
export function exportQuery(params) {
   return request({
     url: envInfo.bgApp.cameraPath + `/camera/consumption/export`,
     method: 'post',
     data: params
   })
 }
/**
* 导出excel
* @param params
*/
export function exportPowerQuery(params) {
    return request({
      url: envInfo.bgApp.cameraPath + `/camera/consumption/power/export`,
      method: 'post',
      data: params
    })
  }
  export function exportWaterQuery(params) {
    return request({
      url: envInfo.bgApp.cameraPath + `/camera/consumption/water/export`,
      method: 'post',
      data: params
    })
  }
/**
 * 删除
 * @param params
 */
export function deleteInfluenceElement(params) {
    return request({
      url: envInfo.bgApp.cameraPath + `/camera/consumption/element/delete/${params.id}`,
      method: 'delete',
    })
  }
  
  /**
 * 新建
 * @param params
 */
export function createInfluenceElement(params) {
    return request({
      url: envInfo.bgApp.tagPath + `/camera/consumption/element/create`,
      method: 'post',
      data: params
    })
  }
